import React , {Component} from 'react';
import {Link} from "react-router-dom";
import home from './../../assets/images/icons/home.svg';
import homeActive from './../../assets/images/icons/home-active.svg';
import product from './../../assets/images/icons/product.svg';
import productActive from './../../assets/images/icons/product-active.svg';
import contact from './../../assets/images/icons/contact.svg';
import contactActive from './../../assets/images/icons/contact-active.svg';
import profile from './../../assets/images/icons/profile.svg';
import profileActive from './../../assets/images/icons/profile-active.svg';
import LoginRegister from "./../section/LoginRegister";

class Footer extends Component{



    constructor(props){

        super(props)
        this.state = {
            userIsLogin : !(localStorage.getItem('api_token') === null || localStorage.getItem('api_token') === undefined || localStorage.getItem('api_token') === "undefined") ,
            loginModalShow : false ,
        }
    }
    loginModalShowHandler(){
        this.setState({
            loginModalShow : !this.state.loginModalShow
        })
    }
    userIsLoginHandler(){
        this.setState({
            userIsLogin : true
        })
    }

    render(){
        const { page } = this.props;
        return(
            <footer id="footer" className="text-decoration-none">
                <div className="container p-0">
                    <div className="row no-gutters justify-content-center">
                        <div className="col-lg-6">

                            <div className="items-container">

                                <div className="row h-100 align-items-center justify-content-between">

                                    <div className="col">
                                        <div className={page === "home" ? "item active" : "item"}>
                                            <Link to="/">
                                                <div>
                                                    <img src={home} alt="bell" className="item-icon" />
                                                    <img src={homeActive} alt="bell" className="item-icon active" />
                                                </div>
                                                <div className="title">
                                                    خانه
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    {/*<div className="col">
                                        <div className={page === "product" ? "item active" : "item"}>
                                            <Link to="/product">
                                                <div>
                                                    <img src={product} alt="bell" className="item-icon" />
                                                    <img src={productActive} alt="bell" className="item-icon active" />
                                                </div>
                                                <div className="title">
                                                    محصولات
                                                </div>
                                            </Link>
                                        </div>
                                    </div>*/}
                                    <div className="col">
                                        <div className={page === "contact" ? "item active" : "item"}>
                                            <Link to="/contact">
                                                <div>
                                                    <img src={contact} alt="bell" className="item-icon" />
                                                    <img src={contactActive} alt="bell" className="item-icon active" />
                                                </div>
                                                <div className="title">
                                                    تماس با ما
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className={page === "profile" ? "item active" : "item"}>

                                            { this.state.userIsLogin === true ?
                                                (
                                                    <Link to="/profile">
                                                        <div>
                                                            <img src={profile} alt="bell" className="item-icon" />
                                                            <img src={profileActive} alt="bell" className="item-icon active" />
                                                        </div>
                                                        <div className="title">
                                                            پروفایل
                                                        </div>
                                                    </Link>
                                                )
                                                :
                                                (
                                                    <div onClick={this.loginModalShowHandler.bind(this)}>
                                                        <div>
                                                            <img src={profile} alt="bell" className="item-icon" />
                                                            <img src={profileActive} alt="bell" className="item-icon active" />
                                                        </div>
                                                        <div className="title">
                                                            پروفایل
                                                        </div>
                                                    </div>
                                                )
                                            }


                                        </div>
                                    </div>


                                </div>

                            </div>



                        </div>
                    </div>
                </div>



                <LoginRegister userIsLoginHandler={this.userIsLoginHandler.bind(this)} loginModalShow={this.state.loginModalShow} loginModalShowHandler={this.loginModalShowHandler.bind(this)} />

            </footer>
        )
    }
}
export default Footer;